import { lazy } from 'react'
import { Details } from '../../views/pages/catalogs/details/Details'
import PriceList from '../../views/pages/catalogs/PriceList'

const Products = lazy(() => import('../../views/pages/catalogs/Products'))
const NewProduct = lazy(() => import('../../views/pages/catalogs/NewProduct'))

const Catalogs = [
  {
    path: '/products',
    element: <Products />,
    meta: { pageTitle: 'Prodotti' }
  },
  {
    path: '/products/:id',
    element: <Details />

  },
  {
    path: '/new-product',
    element: <NewProduct />
  },
  {
    path: '/prices-list',
    element: <PriceList />
  }
]

export default Catalogs
